<template>
  <div class="mx-sm-1 mt-9">
    <div class="page-header">
      <h1 class="page-title fw-bold">Sorties Journalières</h1>
    </div>

    <div class="card mt-3">
      <div class="card-header">
        <div class="card-options">
          <div class="d-flex gap-2">
            <input type="date" v-model="selectedDate" class="form-control w-auto" />
            <button class="btn btn-outline-primary" @click="exportToPDF">
              <i class="fe fe-printer me-2"></i> Exporter PDF
            </button>
          </div>
        </div>
      </div>
      <div class="card-body">
        <div v-if="rows.length && selectedDate" class="mb-2">
  <span class="badge bg-primary">
    {{ rows.length }} produit{{ rows.length > 1 ? 's' : '' }} vend{{ rows.length > 1 ? 'us' : 'u' }} pour le {{ formattedSelectedDate }}
  </span>
        </div>
        <TableWithFilters
            :columns="columns"
            :items="rows"
            :loading="loading"
            enable-export
        >
          <template #cell-totalAmount="{ item }">
            {{ item.totalAmount.toFixed(2) }} FCFA
          </template>
          <template #cell-avgPrice="{ item }">
            {{ item.avgPrice.toFixed(2) }} FCFA
          </template>
          <template #cell-lastSaleTime="{ item }">
            {{ new Date(item.lastSaleTime).toLocaleString() }}
          </template>
        </TableWithFilters>
      </div>
    </div>
  </div>
</template>

<script>
  import TableWithFilters from "@/components/TableWithFilters.vue";
  import jsPDF from "jspdf";
  import autoTable from "jspdf-autotable";

  export default {
    name: "SortiesPage",
    components: { TableWithFilters },
    data() {
      return {
        selectedDate: new Date().toISOString().substr(0, 10), // au format YYYY-MM-DD
        rows: [],
        loading: false,
        columns: [
          { label: "Produit", key: "productName" },
          { label: "Quantité vendue", key: "totalQuantity" },
          { label: "Montant total", key: "totalAmount" },
          { label: "Prix moyen", key: "avgPrice" },
          { label: "Dernier vendeur", key: "lastSeller" },
          { label: "Dernière vente", key: "lastSaleTime" }
        ]
      };
    },
    watch: {
      selectedDate() {
        this.loadSummary();
      }
    },
    computed: {
      formattedSelectedDate() {
        if (!this.selectedDate) return '';
        const d = new Date(this.selectedDate);
        return d.toLocaleDateString('fr-FR', { day: '2-digit', month: '2-digit', year: 'numeric' });
      }
    },
    methods: {
      loadSummary() {
        this.loading = true;
        this.$http
            .get(`/sales/daily-summary?date=${this.selectedDate}`)
            .then(({ data }) => {
              this.rows = data;
            })
            .catch(err => {
              console.error("Erreur chargement sorties journalières :", err);
            })
            .finally(() => {
              this.loading = false;
            });
      },

      exportToPDF() {
        const doc = new jsPDF();
        const date = this.formattedSelectedDate;

        doc.setFontSize(18);
        doc.text("🛒 Sorties Journalières", 14, 20);
        doc.setFontSize(11);
        doc.text(`Date : ${date}`, 14, 28);

        autoTable(doc, {
          startY: 35,
          head: [["Produit", "Quantité", "Montant total", "Prix moyen", "Dernier vendeur", "Dernière vente"]],
          body: this.rows.map(item => [
            item.productName,
            item.quantity,
            `${item.totalAmount.toFixed(2)} FCFA`,
            `${item.avgPrice.toFixed(2)} FCFA`,
            item.lastSeller,
            new Date(item.lastSaleTime).toLocaleString()
          ]),
          styles: { fontSize: 9 },
          headStyles: { fillColor: [52, 152, 219], textColor: 255 },
          columnStyles: {
            2: { halign: 'right' },
            3: { halign: 'right' },
            5: { fontStyle: 'italic' }
          },
          didDrawPage: (data) => {
            const pageHeight = doc.internal.pageSize.height;
            doc.setFontSize(9);
            doc.setTextColor(150);
            doc.text(`Page ${doc.internal.getNumberOfPages()}`, data.settings.margin.left, pageHeight - 10);
          }
        });

        doc.save(`sorties-journalieres-${this.selectedDate}.pdf`);
      }
    },
    mounted() {
      this.loadSummary();
    }
  };
</script>
